<script lang="ts">
import { MessageContentType } from '@smartsupp/smartsupp-message'
import { type Snippet } from 'svelte'

import { testIds } from '@/constants'
import { getBotIdentityId, hasEmailChannelType, type MessageContext, type MessageGroup } from '@/modules/messages'

import MessageAvatar from './MessageAvatar.svelte'

type Props = Pick<MessageGroup, 'agentId' | 'align' | 'isBot' | 'showAvatar' | 'messagesContext'> & {
	children?: Snippet
}

let { align, showAvatar, agentId, isBot, messagesContext, children }: Props = $props()

const isMessageTicketForm = (context: MessageContext[]) => {
	return context.some((context) => context.message.content.type === MessageContentType.TicketForm)
}
</script>

<div
	class={['relative message-group', isMessageTicketForm(messagesContext) ? 'mb-0' : 'mb-4']}
	data-testid={testIds.messageGroup}
>
	<div
		class={[
			'flex flex-col',
			align.isLeft && showAvatar && 'ml-8',
			align.isLeft && 'justify-start items-start',
			align.isRight && 'justify-end items-end',
		]}
	>
		{@render children?.()}
	</div>
	{#if showAvatar}
		<MessageAvatar
			{agentId}
			{isBot}
			isEmailType={hasEmailChannelType(messagesContext)}
			botIdentyId={getBotIdentityId(messagesContext)}
		/>
	{/if}
</div>
